import Vue from 'vue'

const MAIN_DOMAIN = window.MAIN_DOMAIN;



Vue.mixin({
    data: () => {
      return {
        MAIN_DOMAIN
      }
    }
});

Vue.use(require('vue-resource'))

import trainVerification from '../../components/train-verification.vue'

import './train-verification.css'

new Vue({
    el: '#app',
    components: {
        'tuchong-webviews-train-verification': trainVerification
    }
})